module.exports = __webpack_public_path__ + "static/media/Clock.61b4c7c6.svg";